import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import friendinvite from "../assets/images/Homepagesec/Homepageroundimgs/homesportsdraft.png";
import frnbbg from "../assets/images/Homepagesec/sportsdraftsec.png"; // background image

const SportsDraft = () => {
  const { t } = useTranslation();

  return (
    <div
      className="text-center py-16 px-4 md:px-10 lg:px-20 overflow-hidden bg-no-repeat bg-bottom bg-cover"
      style={{
        backgroundImage: `url(${frnbbg})`,
        backgroundColor: "#070b28",
        backgroundPosition: "bottom center",
        backgroundSize: "100%",
      }}
    >
      {/* Section Title */}
      <h2 className="text-[36px] md:text-[48px] font-oswald font-extrabold text-white">
        {t("sportsdraft.title")}
      </h2>

      {/* Underline image */}
      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />

      {/* Tagline */}
      {/* <p className="text-[16px] md:text-[18px] font-proxima font-medium text-[#ffffff] leading-relaxed">
        {t("sportsdraft.tagline")}
      </p> */}

      {/* Text + Image Section */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-20 max-w-6xl mx-auto">
        {/* Left: Text */}
        <div className="w-full md:w-1/2 px-2 md:px-0">
          <p className="text-[18px] md:text-[22px] font-oswald font-semibold text-white text-center md:text-left max-w-xl mx-auto md:mx-0">
             {t("sportsdraft.tagline")}
          </p>
        </div>

        {/* Right: Image */}
        <div className="w-full md:w-1/2 flex justify-center px-2 md:px-0">
          <img
            src={friendinvite}
            alt={t("sportsdraft.inviteImageAlt")}
            className="w-full max-w-[350px] md:max-w-[400px] h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default SportsDraft;
